import React from 'react';
import PropTypes from 'prop-types';
import { accordionWrapper } from './Accordion.module.scss';
import { testAttributes } from './Constants';

const Accordion = ({ children, label, isOpen = false }) => (
    <div id="mortgage-rate-disclosure-container" className={accordionWrapper}>
        <details open={isOpen} data-testid={testAttributes.ACCORDION_CONTAINER} >
            <summary>
                <span>{label}</span>
            </summary>
            {children}
        </details>
    </div>
    
);

Accordion.propTypes = {
    /** Content or children for this Accordion */
    children: PropTypes.node.isRequired,
    /** Label for this Accordion */
    label: PropTypes.string.isRequired,
    /** Controller - defines if the Accordion is open or close by default */
    isOpen: PropTypes.bool
};

export default Accordion;
